// extracted by mini-css-extract-plugin
module.exports = {"delivery-date":"delivery-date___2hI0y"};